export const DEFAULT_TRACKER_ENABLED_CONFIG = {
  disabled: false,
  sessionReplay: {
    enabled: false,
    sampleRate: 0.5,
  },
};

export const DEFAULT_TRACKER_DISABLED_CONFIG = {
  disabled: true,
  sessionReplay: {
    enabled: false,
    sampleRate: 0,
  },
};
